module.exports = require("deepmerge")(require("./config.default.js"), {
  native: {
    name: {
      default: "Congres OEC_D"
    },
    id: "com.mobilespot.aecs.dev",
    // iOS
    appleTeamId: "2TERK78UZD",
    // iosAppStoreUrl: 'https://itunes.apple.com/app/id1484463502',
    // Android
    // 'androidapp-id': 'TODO', // unused?
    playStoreUrl: ""
  },
  web: {
    url: "aecs2022.ms-dev.mobile-spot.com "
  }
});